export const KIOSK = 'KIOSK';
export const CUBOH = 'CUBOH';
export const STOREFRONT_APP_NAMES: string[] = [CUBOH, KIOSK];

// 3rd party apps
export const SKIP_THE_DISHES = 'SKIP';
export const SKIP_THE_DISHES_FULL_APP_KEY = 'SKIPTHEDISHES';
export const UBEREATS = 'UBEREATS';
export const GRUBHUB = 'GRUBHUB';
export const CHOWNOW = 'CHOWNOW';
export const DOORDASH = 'DOORDASH';

// pos
export const SQUARE = 'SQUARE';
export const CLOVER = 'CLOVER';
export const LIGHTSPEED = 'LIGHTSPEED';

// `square-legacy` is deliberately not Cuboh's `square` key — both cards render until legacy
// Square locations migrate.
export const TOAST_POS_KEY = 'toast';
export const SQUARE_LEGACY_POS_KEY = 'square-legacy';
export const SQUARE_LEGACY_POS_LOGO_KEY = 'square';
export const SQUARE_LEGACY_POS_NAME = 'Square (Legacy)';

export const PLATFORMS = 'platforms';
export const POS = 'POS';
export const LOCATIONS = 'locations';
export const EXTRA_INFO = 'extraInfo';
export const REFERRAL_PARTNERS = 'referral_partners';
export const MENUS = 'MENUS';
export const FRESH_KDS = 'FRESH_KDS';

export const VALID_INTEGRATION_TABS: string[] = [PLATFORMS, REFERRAL_PARTNERS, POS, FRESH_KDS];

export const INTEGRATION_FINISH = 'finish';

// integration tabs
export const HIDE_PLATFORMS = ['moduurn', 'mixbowl', 'freshbytes'];
export const POPULAR = [
  'chownow',
  'doordash',
  'skip',
  'ubereats',
  'grubhub',
  'stripe',
  'square',
  'lightspeed',
];
export const REFERRAL = [
  'doordash',
  'skip',
  'ubereats',
  'grubhub',
  'chownow',
  'ritual',
  'flipdish',
];

// statuses
export const INTEGRATION_STATUS = {
  ABANDONED: 'pending - Abandoned',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
} as const;
// Mirrors the CN Integrations list page so both surfaces agree. Card has no case for AVAILABLE
// or PAUSED, so they land on its yellow default with the raw string as the badge label.
export const CN_POS_STATUS = {
  ACTIVE: INTEGRATION_STATUS.ACTIVE,
  AVAILABLE: 'available',
  PAUSED: 'paused',
} as const;
export const ONBOARDING_STATUS_MAP = {
  DOORDASH: {
    ABANDONED: 'Abandoned',
    MENU_BLOCK: 'Menu Block',
    ACTIVATION_BLOCK: 'Activation Block',
    MENU_QUALIFIED: 'Menu Qualified',
    INTEGRATION_ACTIVATED: 'Integration Activated',
    INTEGRATION_PENDING: 'Integration Pending',
    MENU_REQUESTED: 'Menu Requested',
  },
} as const;
export const ONBOARDING_STATUS_CODE_MAP = {
  DOORDASH: {
    DUPLICATE_LOCATION_ID:
      'This location_ID / provider_type combination is being used on another POS store. This partner location is already integrated with a store on DoorDash. Please contact DoorDash Support if this location is incorrectly integrated with an existing DoorDash Store ID.',
    DOORDASH_RETAIL_STORE:
      'This store is using a non-restaurant UI on DoorDash for performance purposes and is not eligible to integrate.',
    VIRTUAL_BRAND_DETECTED:
      'This store is identified as a virtual concept, and the integration you are attempting to onboard does not support unique location_id values across virtual concepts. This store is therefore ineligible to integrate. Please contact DoorDash Support if you believe this to be incorrect for this store.',
    SELF_DELIVERY_DETECTED:
      'The store is currently enabled for Self Delivery, but your integration does not support Self Delivery. Please contact DoorDash Support to disable Self-Delivery and process the financial rate change associated to unblock this store onboarding.',
    DOORDASH_DRIVE_STORE: 'DoorDash Drive stores cannot be onboarded to DoorDash Marketplace.',
    STORE_LIVE_ON_REQUESTED_POS_PROVIDER:
      'This store is already live on the requested POS integration with this location ID.',
    SFDC_ACCOUNT_RECORD_NOT_FOUND:
      'No existing internal DoorDash account found for the store; DoorDash needs to create an internal account for this store before you can proceed. This is not expected to occur; please contact DoorDash for support in resolving if this error is encountered.',
    MENU_PULLING_REQUEST_FAILURE:
      'Menu Job failed due to internal issue. Please retry the menu ingestion.',
    STORE_HOURS_NOT_POPULATED_FAILURE:
      'Menu Job failed due to missing menu hours. Please ensure the menu(s) being ingested have valid hours and retry the menu ingestion.',
    MENU_BLANK_FAILURE:
      'Menu Job succeeded, but the menu has no items. Please ensure the menu(s) being ingested have valid contents and retry the menu ingestion.',
    MENU_JOB_FAILURE:
      'Menu Job failed due to issues with the menu. This may be due to missing contents, null category/item names, or other issues with the menu.',
    MENU_COMPLIANCE_FAILURE:
      'Menu Job failed due to identified as having non-compliant items. Please ensure you have completed the proper compliance forms on DoorDash or remove the non-compliant items, and retry the menu ingestion.',
    STORE_NOT_ACTIVE:
      'Store could not be successfully activated. Please verify details in DoorDash Merchant Portal or contact DoorDash Support.',
  },
} as const;

// actions
export const INTEGRATION_ACTIONS = {
  CONNECT: 'connect',
  SUCCESS: 'success',
  MENU_SELECT: 'menuSelect',
} as const;
export const REDIRECT_ACTIONS: string[] = [
  INTEGRATION_ACTIONS.CONNECT,
  INTEGRATION_ACTIONS.SUCCESS,
];
export const SUBMIT_ACTIONS = {
  SUBMIT: 'submit',
  CONNECT: 'connect',
  VERIFY: 'verify',
  OK: 'ok',
  CONTINUE: 'continue',
} as const;
export const CORE_ACTIONS = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
} as const;

export const COLUMNS = {
  xs: 1,
  sm: 1,
  md: 1,
  lg: 2,
  xl: 2,
  xxl: 3,
} as const;

export const COMPONENTS_WITH_RULES = ['Input', 'Password', 'RadioGroup', 'Select'];

export const FAILURE_STATUS = 'failure';
export const SUCCESS_STATUS = 'success';

export const ONE_DASHBOARD = 'one_dashboard';

export const DEACTIVATION_TEXT = 'Reach out to customer support to deactivate integration.';

export const TOAST_DASHBOARD =
  import.meta.env.VITE_DEPLOY_ENV === 'prod'
    ? 'https://www.toasttab.com/restaurants/admin/menus/homepage#'
    : 'https://sandbox.eng.toasttab.com/restaurants/admin/home';

export const INTEGRATION_ERROR_TYPE = {
  integrationConnectionError: 'Integration Connection Error',
  integrationFormError: 'Integration Form Error',
  integrationMenuAttachError: 'Integration Menu Attachment Error',
} as const;

export const INTEGRATION_ERROR_MESSAGE = {
  default:
    'There was an error submitting your request. Please try again in a few seconds or contact support if the problem persists',
  noStoresFound: 'No stores found for this account.',
} as const;

export const INTEGRATION_MENU_ATTACH_ERROR_MESSAGE = {
  default:
    'There was an error attaching the menu to the integration. Please attach a menu using menu management',
} as const;
